<template>
  <VDialog
    :model-value="visible"
    max-width="520"
    persistent
  >
    <VCard class="pa-6">
      <VCardTitle class="text-h5 font-weight-bold px-0 pt-0">
        {{ $lang(message, 'title') }}
      </VCardTitle>

      <VCardText class="px-0 text-body-1">
        <div v-html="$lang(message, 'content')" />
      </VCardText>

      <VCardActions class="px-0 pb-0 justify-end flex-wrap ga-2">
        <VBtn
          v-if="$lang(message, 'cta_label')"
          color="primary"
          @click="onCta"
        >
          {{ $lang(message, 'cta_label') }}
        </VBtn>
        <VBtn
          variant="outlined"
          color="secondary"
          @click="onDismiss"
        >
          {{ $t('login-popup.dismiss') }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script setup>
import _ from 'lodash'
import { useLoginPopupReminder } from '@/composables/useLoginPopupReminder'

const {
  message,
  visible,
  closePopup,
} = useLoginPopupReminder()

function onDismiss() {
  closePopup()
}

function onCta() {
  const url = _.get(message.value, 'cta_url')

  closePopup()

  if (!url) {
    return
  }

  if (/^https?:\/\//i.test(url)) {
    window.location.href = url
    
    return
  }

  navigateTo(url)
}
</script>
